import img1 from "../../../../assets/OurPCourse/course-img1.png";
import img2 from "../../../../assets/OurPCourse/course-img2.png";
import img3 from "../../../../assets/OurPCourse/course-img3.png";
import { BsPersonCircle } from "react-icons/bs";
import { HiOutlineUserGroup } from "react-icons/hi";
import { BiBookAlt } from "react-icons/bi";


export const SingleCourseData = [
    {
        id: 1,
        image: img1,
        price:"$6000",
        title: "Jone Smit",
        text: "Java Programming Master Class For Software Developer Education",
        lesson: "0 Lessons",
        student: "15 Students",
        profileicon: <BsPersonCircle />,
        lessonicon:  <BiBookAlt />,
        studenticon: <HiOutlineUserGroup />
    },
    {
        id: 2,
        image: img2,
        price:"$59",
        title: "Jone Smit",
        text: "Java Programming Master Class For Software Developer Education",
        lesson: "0 Lessons",
        student: "15 Students",
        profileicon: <BsPersonCircle />,
        lessonicon:  <BiBookAlt />,
        studenticon: <HiOutlineUserGroup />
    },
    {
        id: 3,
        image: img3,
        price:"$59",
        title: "Jone Smit",
        text: "Java Programming Master Class For Software Developer Education",
        lesson: "0 Lessons",
        student: "15 Students",
        profileicon: <BsPersonCircle />,
        lessonicon:  <BiBookAlt />,
        studenticon: <HiOutlineUserGroup />
    },
    
]